var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-header"},[_c('el-row',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"header-title"},[_vm._v(_vm._s('AI体适能监测系统'))]),_vm._v(" "),_c('s-personal')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f8a952","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = hLc2
// module chunks = 94